import { useEffect, useState, useCallback, useContext, ReactNode, CSSProperties, HTMLAttributes  } from "react";
import { CacheDataLoader } from "components";
import 'react-vertical-timeline-component/style.min.css';
import commonStyles from "styles/common";
import viewsStyles from "styles/views";
import "styles/verticaltimeline.custom.css";
import "./style.css";
import { Grid2 as Grid, Container, CircularProgress } from "@mui/material";
import EventsEmitter from "events/EventsEmitter";
import { tss } from "tss-react";
import { ProcessingTimeCard } from "./ProcessingTimeCard";
import { CurrentPlanCard } from "./CurrentPlanCard";
import { ActiveUsersCard } from "./ActiveUsersCard";
import { ProjectsCard } from "./ProjectsCard";
import { ViewsCard } from "./ViewsCard";
import { DemosCard } from "./DemosCard";
import { PendingCard } from "./PendingCard";
import { IssuesCard } from "./IssuesCard";
import { ReportsCard } from "./ReportsCard";
//import { Scrollbars } from "react-custom-scrollbars";
import {AppContext} from "views/Loader";
import { useSelector } from 'react-redux';
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import { useHistory } from "react-router-dom";
import { StorageUtils } from "services/UtilsService";
import { useTheme } from "@mui/material/styles";
import CustomScroll from "components/CustomScroll";

const range = (start: number, end: number) => Array.from({length: (end - start)}, (v, k) => k + start);
const useStyles = tss.create(() => ({
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto',
        width: 'unset',
        minWidth: '30px',
        minHeight: '30px',
    }
}));



export default function Home() {
    const [data, setData] = useState<any>(null);
    const { classes: viewsClasses } = viewsStyles();
    const [progress, setProgress] = useState(0);
    const [loaded, setLoaded] = useState<any>(false);
    const [loadingEnvironment, setLoadingEnvironment] = useState<any>(false);
    const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || "all");

    const theme = useTheme();

    const [nbProjects, setNbProjects] = useState(0)
    const [nbViews, setNbViews] = useState(0)
    const [nbPending, setNbPending] = useState(0)
    const [nbIssue, setNbIssue] = useState(0)
    const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;
    const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
    const Swal = useSwalWrapper();
    const history = useHistory();

    const sweetAlerts = () => {
        Swal.fire({
        title: 'Your account has limited access!',
        text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
        imageWidth: 450,
        imageHeight: 200,
        imageAlt: 'Custom image',
        confirmButtonText: "Upgrade my plan",
        }).then((result) => {
        result.isConfirmed && history.push("/profile");
        });
    };

    useEffect(() => {
        var updateFilter = (filter: string) => {
            setFilter(filter);
        };
        EventsEmitter.on("updateFilter", updateFilter);
        return () => {
            EventsEmitter.removeEventListener("updateFilter", setFilter);
        };
    }, []);

    const onDataLoad = useCallback((cacheData: any) => {
        if(loaded) return;

        setData(cacheData);
        
        setLoaded(true);
    }, [data, setData, loaded, setLoaded]);
    
    const { 
        tourActive,
        setRunTour,
        setStepIndex
    } = useContext<any>(AppContext);

    useEffect(() => {
        setTimeout(() => {
            if(!tourActive) return;
            
            setStepIndex(0);
            setRunTour(true);
        }, 2000);
    }, [tourActive]);

    useEffect(() => {
        if(data !== null) {
            const projectsList = data["projects"];
            const keys = Object.keys(projectsList).filter((id: string) => !demoProjectsHidden || !defaultProjects.includes(id)) ;
            setNbProjects(keys.length)
            var currentList: any = [];
            var currentIssuesList : any = [];
            const views = data["views"];
            let viewsArray: any = Object.values(views).filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.project)) ;
            setNbViews(viewsArray.length)

            const entities = data["entities"];
            let comptIssue = 0;
            let comptPending = 0;
        
          

            Object.entries(entities).map((entry: any, index: number) => {
                var id = entry[0];
               
                var pending: any = Object.values(entry[1]).filter((p: any) => {
                    return p.state === "PARTIAL" && p.type === "FILE" && p.name;
                });

                var issue: any = Object.values(entry[1]).filter((p: any) => {
                    return p.state === "ERROR" && p.name;
                });

               
                if (projectsList[id] && pending.length > 0 && (/*!demoProjectsHidden || */!defaultProjects.includes(id))) {
                    currentList.push(projectsList[id]);
                    comptPending += pending.length;
                }

                if (projectsList[id] && issue.length > 0 && (/*!demoProjectsHidden || */!defaultProjects.includes(id))) {
                    currentIssuesList.push(projectsList[id]);
                    comptIssue += issue.length;
                }
                setNbPending(comptPending)
                setNbIssue(comptIssue)

                return true;
            });
        }
     
    }, [data]);

    useEffect(() => {
        
        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        const handleLoadingEnvironment = (state: boolean) => {
            setLoadingEnvironment(state);
        };

        EventsEmitter.on("projects_progress", handleProgress);
        EventsEmitter.on("loading_environment", handleLoadingEnvironment);
        
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
            EventsEmitter.removeEventListener("loading_environment", handleLoadingEnvironment);
        };
      
    }, [data]);

    return (
        <CacheDataLoader onDataLoad={onDataLoad}>
             {/* <ObjectCount project={nbProjects} view={nbViews} pending={nbPending} issue={nbIssue}/> */}
            <div className={viewsClasses.root}>
                <Container
                    maxWidth={false}
                    sx={{
                        //maxWidth: CONTAINER_MAX_WIDTH,
                        display: 'flex',
                        minWidth: 0,
                        flex: 1,
                        flexDirection: 'column',
                        p: '0 20px'
                    }}
                    disableGutters
                >
                    {/*<div className={cx(common.middle, viewsClasses.topHeader)}>
                        <BreadCrumbs label="Dashboard" className="mainTitle"/>
                    </div>*/}
                    <CustomScroll
                        style={{ overflowX: "hidden", height: "calc(100vh - 100px)"}}
                    >
                       { loadingEnvironment ? (
                            <CircularProgress />
                        ) : (
                            <Grid container spacing={3.5} sx={{padding: '0 20px 50px'}}>
                                <Grid size={{ xs:12, sm:6, lg:4}}>
                                    <ProcessingTimeCard />
                                </Grid>
                                <Grid size={{ xs:12, sm:6, lg:4}}>
                                    <CurrentPlanCard />
                                </Grid>
                                <Grid size={{ xs:12, sm:6, lg:4}}>
                                    <ActiveUsersCard />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                   <ProjectsCard  title="Projects" sweetAlerts={sweetAlerts} filter={filter} />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                    <ViewsCard title="Views" sweetAlerts={sweetAlerts} filter={filter} />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                   <PendingCard title="Pending" filter={filter} />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                    <DemosCard title="Demos" />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                   <IssuesCard title="Issues" filter={filter} />
                                </Grid>
                                <Grid size={{ xs:12, sm:12, lg:6}}>
                                    <ReportsCard title="Reports" filter={filter} />
                                </Grid>
                                
                                { /*
                                    <Grid size={{ xs: 12, lg: 12, xl: 12 }}>
                                        <ProjectsList nb={nbProjects}/>
                                    </Grid>
                                    <Grid size={{ xs: 12, lg: 12, xl: 7 }}>
                                        <ViewsList nb={nbViews}/>
                                    </Grid>
                                    <Grid size={{ xs: 12, lg: 5 }}>
                                        <ReportList />
                                    </Grid>
                                    <Grid size={{ xs: 12, lg: 6 }}>
                                        <IssuesList nb={nbIssue}/>
                                    </Grid>
                                    <Grid size={{ xs: 12, lg: 6 }}>
                                        <PendingList nb={nbPending}/>
                                    </Grid>
                                */}
                            </Grid>
                        )}
                    </CustomScroll>
                </Container>
            </div>
        </CacheDataLoader>
    );
}
